// src/components/PhotoSlider.tsx
import React, { useState, useEffect } from 'react';
import './PhotoSlider.css';

interface PhotoSliderProps {
  images: string[]; // Array of image URLs passed as props
}

const PhotoSlider: React.FC<PhotoSliderProps> = ({ images }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % images.length);
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="photo-slider">
      <img src={images[currentSlide]} alt={`Slide ${currentSlide + 1}`} className="slider-image" />
      <div className="slider-indicators">
        {images.map((_, index) => (
          <div
            key={index}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
          />
        ))}
      </div>
    </div>
  );
};

export default PhotoSlider;
